import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const usePlatformGoalBenefits = (
  platformGoalBenefitsKey,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `api/platform-goal-benefits/${platformGoalBenefitsKey}`;

  const {
    data,
    data: platformGoalBenefits,
    isValidating,
    ...rest
  } = useFetch(
    platformGoalBenefitsKey ? key : null,
    { useCamelCase: false, hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(platformGoalBenefits || {});
  return {
    key,
    platformGoalBenefits,
    isValidating,
    ...rest
  };
};

export default usePlatformGoalBenefits;
